/* tslint:disable */
/* eslint-disable */
export enum WorkProjectAnlageSupplyTypesEnum {
  Uberschuss = '\xDCberschuss',
  Produktionszahler = 'Produktionsz\xE4hler',
  Evg = 'EVG',
  Inselanlage = 'Inselanlage'
}
